:host{height:100%;display:block}app-add-edit-project{height:100%}
/*# sourceMappingURL=new-project-overview.component-HU4XESBN.css.map */
